import { render, staticRenderFns } from "./NewCategorySelect.vue?vue&type=template&id=4c2468db&"
import script from "./NewCategorySelect.vue?vue&type=script&lang=js&"
export * from "./NewCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./NewCategorySelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports